import { Button, message, Spin, Table } from 'antd';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import BookingApi from '../../functions/api/booking/BookingApi';
import MyUtil from '../../functions/MyUtil';

export default class TableViewPromo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bookingWithPromoCode: [],
      code: props.match.params.promo_code,
    };
  }

  convertToLevelsFormat = async (bookingPromos) => {
    const levels = (await BookingApi.getLevels()) || [];
    return bookingPromos.map((b) => {
      const lv = levels.find((l) => l.books_stt_id === b.books_stt_id);
      return {
        ...b,
        book_stt_name: lv.book_stt_name,
      };
    });
  };

  async componentDidMount() {
    const { code } = this.state;
    let dataPromo = [];
    const bookingWithPromoCode = await BookingApi.getBookingWithPromoCode(code);
    dataPromo = await this.convertToLevelsFormat(bookingWithPromoCode);

    if (dataPromo.length === 0) {
      message.info('Mã code không được sử dụng');
      this.props.history.push('/promotion');
    }

    this.setState({
      bookingWithPromoCode: dataPromo,
    });
  }

  render() {
    const { bookingWithPromoCode, code } = this.state;
    if (bookingWithPromoCode.length === 0) {
      return <Spin />;
    }

    const bookingWithPromoColumn = [
      {
        title: 'ID',
        dataIndex: 'book_id',
        key: 'book_id',
      },
      {
        title: 'Booking Code',
        dataIndex: 'book_code',
        key: 'book_code',
      },
      {
        title: 'Phone',
        dataIndex: 'cstm_phon',
        key: 'cstm_phon',
      },
      {
        title: 'Tên khách',
        dataIndex: 'cstm_name',
        key: 'cstm_name',
      },
      {
        title: 'Thành phố',
        dataIndex: 'city_name',
        key: 'city_name',
      },
      {
        title: 'Loại xe',
        dataIndex: 'vhc_type_name',
        key: 'vhc_type_name',
      },
      {
        title: 'Mã được dùng',
        dataIndex: 'promo_code',
        key: 'promo_code',
      },
      {
        title: 'Số tiền được trừ',
        dataIndex: 'promo_val',
        align: 'right',
        key: 'promo_val',
        render(promo_val) {
          return +promo_val > 100 ? `${promo_val} VNĐ` : `${promo_val} %`;
        },
      },
      {
        title: 'Tổng tiền của booking',
        dataIndex: 'book_prie_tota',
        align: 'right',
        key: 'book_prie_tota',
        render: MyUtil.currencyFormat,
      },
      {
        title: 'Số ngày thuê',
        dataIndex: 'book_day_num',
        align: 'right',
        key: 'book_day_num',
      },
      {
        title: 'Trạng thái hiện tại của booking',
        dataIndex: 'book_stt_name',
        key: 'book_stt_name',
      },
    ];
    return (
      <>
        <h1>Đơn sử dụng mã {code}</h1>
        <Table
          rowKey="book_id"
          size="small"
          columns={bookingWithPromoColumn}
          dataSource={bookingWithPromoCode}
          scroll={{ x: 'max-content' }}
        />
        <Link to="/promotion">
          <Button>Quay lại</Button>
        </Link>
      </>
    );
  }
}
